import Model from 'src/app/common/model';

export default class ObservationTypeModel extends Model {
  id: string;
  name: string;
  description: string;
  created_by: string;
  updated_by: string;
  createdAt: Date;
  updatedAt: Date;

  constructor() {
    super();
  }
}

